import { defineStore } from 'pinia';
import { configRequest } from 'config-request';
import { useGlobalStore } from './global';
import { useFeatureListStore } from './feature-list';
import { getRequestIns } from '../requestIns';
export const useCombinationListStore = defineStore('combination-list', {
    actions: {
        /**
         * 查询组合包弹窗列表
         * @param params
         */
        async getCombinationList(params, update = true) {
            try {
                const globalStore = useGlobalStore();
                const result = await configRequest(getRequestIns()).combinationList(params, {
                    showToast: params?.add_option_list ? true : false,
                });
                // TODO MOCK
                // const result = discountResult
                const option_list = result?.data?.option_list_after_select;
                if (option_list?.length) {
                    const optionList = option_list.map((optionItem) => {
                        return {
                            featureCode: optionItem.feature_code,
                            code: optionItem.code,
                            selected: true,
                        };
                    });
                    console.log('>>>', optionList);
                    update && globalStore.batchUpdateConfig(optionList);
                    // 组合优惠接管本次改配，套装价以本接口结果为准（同 package-popup.ts 的处理方式），
                    // 因为下面的 batchUpdateConfig 各调用方普遍传 showToast=false，不会走 rule/check 刷新套装价
                    useFeatureListStore().setRuntimePackagePriceList(result?.data?.package_price_list ?? []);
                }
                console.log('---更新数据---');
                // TODO MOCK
                // const
                return result?.data ?? null;
            }
            catch (error) {
                return null;
            }
        },
    },
});
